import AccreditationEntity from './AccreditationEntity';

export default AccreditationEntity
